<template>
  <v-app class="app dashboard" id="inspire">
    <app-drawer
      :show-drawer="showDrawer"
      @visibility-change="showDrawer = $event"
      class="app--drawer"
    ></app-drawer>
    <app-toolbar
      :notificationsTotal="notificationsTotal"
      @side-icon-click="handleDrawerVisiable"
      class="app--toolbar"
    ></app-toolbar>

    <v-content>
      <main class="page-wrapper">
        <router-view :key="$route.fullPath"></router-view>
      </main>

      <footer class="app-footer">
        <div class="app-footer__accent"></div>
        <div class="app-footer__content">
          <div class="app-footer__brand">
            <span class="app-footer__year">© {{ currentYear }}</span>
            <span class="app-footer__name">Vanguard Transit Solutions</span>
          </div>
          <div class="app-footer__links">
            <a
              href="http://www.pharma-customssolutions.com/"
              target="_blank"
              rel="noopener"
              >Pharma Customs Solutions</a
            >
            <span class="app-footer__sep" aria-hidden="true">·</span>
            <span>Desarrollado por <strong>Teknubis</strong></span>
          </div>
        </div>
      </footer>
    </v-content>

    <app-fab></app-fab>

    <v-dialog
      max-width="280"
      persistent
      v-model="loading"
      content-class="loading-dialog"
    >
      <loading></loading>
    </v-dialog>
  </v-app>
</template>

<script>
import AppDrawer from '@/components/AppDrawer'
import AppToolbar from '@/components/AppToolbar'
import AppFab from '@/components/AppFab'
import loading from './../../views/dialog/DialogLoading'

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    loading,
  },

  data() {
    return {
      showDrawer: !this.$vuetify.breakpoint.smAndDown,
      notificationsTotal: 0,
      showDrawerRight: false,
      loading: false,
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
  watch: {
    '$route.fullPath'() {
      if (this.$vuetify.breakpoint.smAndDown) this.showDrawer = false
    },
  },
  methods: {
    handleDrawerVisiable() {
      this.showDrawer = !this.showDrawer
    },
    openFile(file) {
      this.loading = true
      // This time is only to show the animation.
      setTimeout(() => {
        this.loading = false
        window.location.href = this.$config.BASE_URL + file
      }, 3000)
    },
  },
  sockets: {
    invoicesTransitFile(response) {
      this.openFile(response.file)
    },

    labsFile(response) {
      this.openFile(response.file)
    },
    distFile(response) {
      this.openFile(response.file)
    },
    productBatchesFile(response) {
      this.openFile(response.file)
    },
    downloadInvoiceAttachments(response) {
      this.openFile(response.file)
    },
    accountStatementsFile(response) {
      this.openFile(response.file)
    },
    usersFile(response) {
      this.openFile(response.file)
    },
    realtimeFeed(data) {
      this.$toast.info(data.action)
      this.$store.dispatch('feeds/save', data).then(total => {
        this.notificationsTotal = total
      })
    },
  },
}
</script>

<style scoped lang="stylus">
.page-wrapper
  min-height: calc(100vh - 64px - 56px)
  background: #f6f8fc

/* === Footer moderno === */
.app-footer
  position: relative
  background: #ffffff
  border-top: 1px solid #eef0f4
  padding: 14px 24px
  z-index: 1

  &__accent
    position: absolute
    top: -1px
    left: 0
    right: 0
    height: 2px
    background: linear-gradient(90deg, #254f87 0%, #c79a2b 50%, #e5252a 100%)
    opacity: 0.85

  &__content
    display: flex
    align-items: center
    justify-content: space-between
    flex-wrap: wrap
    gap: 12px

  &__brand
    display: flex
    align-items: center
    gap: 10px
    font-size: 12px

  &__year
    color: #94a3b8
    font-weight: 500
    letter-spacing: 0.02em

  &__name
    color: #254f87
    font-weight: 700
    letter-spacing: 0.02em

  &__links
    display: flex
    align-items: center
    gap: 8px
    font-size: 11.5px
    color: #5f6880
    flex-wrap: wrap

  &__links a
    color: #5f6880
    text-decoration: none
    font-weight: 500
    transition: color .15s ease

  &__links a:hover
    color: #e5252a

  &__sep
    color: #cbd5e1
    font-weight: 700

@media (max-width: 700px)
  .app-footer
    padding: 12px 16px

    &__content
      flex-direction: column
      align-items: flex-start
      gap: 6px

    &__links
      gap: 6px
</style>

<style>
/* === Snackbar === */
.app-snackbar .v-snack__wrapper {
  border-radius: 12px !important;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18) !important;
  font-weight: 500;
}

.app-snackbar .v-snack__content {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 16px;
}

/* === Loading dialog === */
.loading-dialog {
  border-radius: 16px !important;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.25) !important;
  overflow: hidden;
}
</style>
